"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaneErrorScreen = exports.PANE_ERROR_RELOAD_LABEL = exports.PANE_ERROR_MESSAGE = void 0;
var _react = _interopRequireDefault(require("react"));
var _taskpaneReload = require("../utils/taskpane-reload");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PANE_ERROR_MESSAGE = exports.PANE_ERROR_MESSAGE = "Something went wrong and the add-in stopped. Reload to continue.";
var PANE_ERROR_RELOAD_LABEL = exports.PANE_ERROR_RELOAD_LABEL = "Reload";
var paneErrorStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "24px",
    color: "#1f2937",
    textAlign: "center",
    gap: "16px"
  },
  message: {
    margin: 0,
    fontSize: "14px",
    lineHeight: "20px"
  },
  reloadButton: {
    padding: "8px 16px",
    border: "1px solid #1f2937",
    borderRadius: "4px",
    background: "#ffffff",
    color: "#1f2937",
    fontSize: "14px",
    cursor: "pointer"
  }
};
var PaneErrorScreen = exports.PaneErrorScreen = function PaneErrorScreen() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: paneErrorStyles.container,
    role: "alert",
    "data-sentry-component": "PaneErrorScreen",
    "data-sentry-source-file": "PaneErrorScreen.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      style: paneErrorStyles.message,
      children: PANE_ERROR_MESSAGE
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      style: paneErrorStyles.reloadButton,
      onClick: _taskpaneReload.reloadTaskpane,
      children: PANE_ERROR_RELOAD_LABEL
    })]
  });
};